{
  "heading": "Recipients",
  "byline_line_one": "Keep your group in the loop by adding them as a text message recipient",
  "add_recipient": "Add recipient",
  "members_table": {
    "name": "Name",
    "phone": "Phone"
  },
  "more_menu": {
    "aria_label": "More",
    "remove": "Delete"
  },
  "confirm_remove": {
    "title": "Delete {{name}}?",
    "confirm": "Yes, delete"
  },
  "add_member_modal": {
    "heading": "Add a text recipient",
    "limit": "({{remaining}} remaining)",
    "already_exists_error": "A recipient with this phone number already exists",
    "submit": "Add",
    "name": {
      "label": "Name",
      "required": "Name is required"
    },
    "phone": {
      "label": "Phone number",
      "invalid": "Enter a valid phone number"
    },
    "authorized": {
      "label": "I am authorized to send text messages to this number",
      "required": "Please confirm"
    },
    "success_toast": "✨ Recipient added",
    "privacy": "When you add a text message recipient, we'll send each person a text welcoming them to Agenda Hero. After that, only you control who gets a text and when. Read our <2>privacy policy</2>."
  }
}
